
export {} from '@clayui/slider';
import __x__ from '@clayui/slider';export default __x__;